
/**
 * Simplifies provider names by removing:
 * 1. Commas and anything after them
 * 2. Common business entity suffixes like "Inc." and "LLC" even without commas
 * 
 * @param name The provider name to simplify
 * @returns The simplified name
 */
export const simplifyProviderName = (name: string): string => {
  let result = name;
  
  // First, handle any commas (this takes priority)
  const commaIndex = result.indexOf(',');
  if (commaIndex !== -1) {
    result = result.substring(0, commaIndex).trim();
  }
  
  // Then, remove common business entity suffixes even if no comma is present
  // Using regex with word boundaries to avoid partial matches
  result = result
    .replace(/\s+(?:Inc\.?|LLC|L\.L\.C\.?|Corporation|Corp\.?|Company|Co\.?|Group|Ltd\.?)$/i, '')
    .trim();
  
  return result;
};

/**
 * Check if a provider name contains a comma or common business entity suffixes
 * and needs simplification
 * 
 * @param name The provider name to check
 * @returns Boolean indicating if the name needs simplification
 */
export const nameNeedsSimplification = (name: string): boolean => {
  // Check for commas
  if (name.includes(',')) {
    return true;
  }
  
  // Check for common business entity suffixes
  const suffixPattern = /\s+(?:Inc\.?|LLC|L\.L\.C\.?|Corporation|Corp\.?|Company|Co\.?|Group|Ltd\.?)$/i;
  return suffixPattern.test(name);
};
